import { buildQueryParams } from '@/helper/utils';
import {
  CreateSurveyDto,
  CreateSurveyResponseDto,
  GetAllSurveysResponseDto,
  GetSurveyStatsResponseDto,
  SurveyFilters,
} from '@/types/survey.types';
import api from '../instance';

const getToken = () => localStorage.getItem('accessToken');

export const surveyManagementService = {
  createSurvey: async (data: CreateSurveyDto): Promise<CreateSurveyResponseDto> => {
    try {
      const res = await api.projectApi.post<CreateSurveyResponseDto>(`/survey`, data, {
        headers: {
          'x-show-loader': 'true',
          'X-Mm-Service': 'mm-content-mgmt-svc',
        },
      });
      return res.data;
    } catch (error: unknown) {
      if (error instanceof Error) throw error;
      throw new Error('Error creating project');
    }
  },
  getSurveysList: async (filters?: SurveyFilters) => {
    const params = filters ? buildQueryParams(filters) : {};
    try {
      const res = await api.projectApi.get<GetAllSurveysResponseDto>(`/survey`, {
        params,
        headers: {
          'x-show-loader': 'true',
          'X-Mm-Service': 'mm-content-mgmt-svc',
        },
      });

      return res.data;
    } catch (error: unknown) {
      if (error instanceof Error) throw error;
      throw new Error('Error fetching surveys');
    }
  },
  getAllSurveysBasedOnLanguages: async (data: any) => {
    try {
      const res = await api.projectApi.post<GetAllSurveysResponseDto>(`/survey/language`, data, {
        headers: {
          Authorization: `Bearer ${getToken()}`,
          'Content-Type': 'application/json',
        },
      });

      return res.data;
    } catch (error) {
      if (error instanceof Error) throw error;
      throw new Error('Error fetching surveys');
    }
  },
  getSurveyStats: async () => {
    try {
      const res = await api.projectApi.get<GetSurveyStatsResponseDto>(`/survey/count`, {
        headers: {
          'x-show-loader': 'true',
          'X-Mm-Service': 'mm-content-mgmt-svc',
        },
      });

      return res.data;
    } catch (error: unknown) {
      if (error instanceof Error) throw error;
      throw new Error('Error fetching surveys');
    }
  },
  getSurveyById: async (id: string) => {
    try {
      const res = await api.projectApi.get(`/survey/${id}`, {
        headers: {
          'X-Mm-Service': 'mm-content-mgmt-svc',
          'x-show-loader': 'true',
        },
      });
      return res.data;
    } catch (error: unknown) {
      if (error instanceof Error) throw error;
      throw new Error('Error get survey by id');
    }
  },
  getSurveyQuestions: async (id: string) => {
    try {
      const res = await api.projectApi.get(`/survey/${id}/questions`, {
        headers: {
          'X-Mm-Service': 'mm-content-mgmt-svc',
          'x-show-loader': 'true',
        },
      });
      return res.data;
    } catch (error: unknown) {
      if (error instanceof Error) throw error;
      throw new Error('Error fetching survey questions');
    }
  },
  updateSurvey: async (
    id: string,
    data: Partial<CreateSurveyDto>,
  ): Promise<CreateSurveyResponseDto> => {
    try {
      const res = await api.projectApi.put<CreateSurveyResponseDto>(`/survey/${id}`, data, {
        headers: {
          'x-show-loader': 'true',
          'X-Mm-Service': 'mm-content-mgmt-svc',
        },
      });
      return res.data;
    } catch (error: unknown) {
      if (error instanceof Error) throw error;
      throw new Error('Error updating project');
    }
  },
  updateSurveyStatus: async (
    id: string,
    data: Partial<CreateSurveyDto>,
  ): Promise<CreateSurveyResponseDto> => {
    try {
      const res = await api.projectApi.put<CreateSurveyResponseDto>(`/survey/${id}`, data, {
        headers: {
          'X-Mm-Service': 'mm-content-mgmt-svc',
        },
      });
      return res.data;
    } catch (error: unknown) {
      if (error instanceof Error) throw error;
      throw new Error('Error updating survey status');
    }
  },
  deleteSurvey: async (id: string, deletedBy: number): Promise<CreateSurveyResponseDto> => {
    try {
      const res = await api.projectApi.delete<CreateSurveyResponseDto>(`/survey/${id}`, {
        params: {
          deletedBy,
        },
        headers: {
          'x-show-loader': 'true',
          'X-Mm-Service': 'mm-content-mgmt-svc',
        },
      });
      return res.data;
    } catch (error: unknown) {
      if (error instanceof Error) throw error;
      throw new Error('Error deleting project');
    }
  },
  exportSurveys: async () => {
    try {
      const res = await api.projectApi.get('/survey/bulk-export', {
        responseType: 'blob',
      });
      return res.data;
    } catch (error) {
      if (error instanceof Error) throw error;
      throw new Error('Error exporting surveys');
    }
  },
};
